import { HtsReadinessPillarKey } from "../constants";
import { HtsReadinessPillarConfig } from "../schemas";

export const volunteering: HtsReadinessPillarConfig = {
  key: HtsReadinessPillarKey.VOLUNTEERING,
  label: "Community Contribution",
  // Half weight — this pillar's absence is common and not disqualifying the
  // way a weak score elsewhere is.
  compositeWeight: 0.5,
  definition:
    "Time given to benefit the community, a group, or an individual — evidence of service orientation, which many high-trust agencies weigh. Formal registered volunteering counts, but so does lightly-paid people-facing work, caregiving (not only for a family member), coaching, and cultural or faith community roles — these are primary qualifying activity here, not a narrow carve-out for candidates with no free time.",
  dataSourceNote:
    "Derived — the volunteer/community-activity list with its hours-per-month and duration fields; one friendly follow-up where history has lapsed. Lightly-paid people-facing work, caregiving, coaching, and cultural/faith community roles receive full credit alongside unpaid, formally registered volunteering.",
  dimensions: [
    {
      key: "sustainedDuration",
      label: "Sustained Duration",
      weight: 0.4,
      anchors: {
        0: "No history to measure.",
        25: "Under 3 months total.",
        50: "3–6 months sustained, or 6–12 months with interruptions.",
        75: "6–12 months sustained.",
        100: "12+ months sustained at a consistent level.",
      },
    },
    {
      key: "currentCommitment",
      label: "Current Commitment",
      weight: 0.3,
      anchors: {
        0: "No current activity, and none in the past.",
        25: "Past minimal activity only, lapsed with no identifiable reason.",
        50: "Lapsed for identifiable work/family reasons, or newly started (under 3 months) at any level.",
        75: "Active, but irregularly or without a consistent cadence.",
        100: "Currently active on a consistent, ongoing basis.",
      },
    },
    {
      key: "relevanceDepthOfService",
      label: "Relevance & Depth of Service",
      weight: 0.3,
      anchors: {
        0: "Not applicable — no service to assess.",
        25: "Passive or event-based only (one-off events, behind-the-scenes tasks with no people contact).",
        50: "General community service with some people contact.",
        75: "People-facing service roles with regular direct interaction, including lightly-paid people-facing work.",
        100: "Structured coaching, mentoring, crisis management, caregiving, or interpersonal care — including through a cultural or faith community role.",
      },
    },
  ],
  topIndicators: [
    "Sustained people-facing service",
    "A role involving coaching, caregiving, or care",
    "Activity that survives a busy schedule",
  ],
  scoringNotes: [
    "A lapsed contributor with a credited reason scores on what they sustained before the lapse for Duration and Relevance, with Current Commitment at 50.",
    "Claimed commitment that contradicts an empty activity list is probed before scoring; unresolved conflicts are noted for the coach.",
    "A documented full-time work-plus-dependents load, or caregiving (not limited to a family member), scores as equivalent to Current Commitment and Sustained Duration at a stated level.",
  ],
};
